import axios from 'axios'

// Instância para o backend-core em que 403/404 são respostas de negócio, não sessão
// inválida. O interceptor global (helpers/api.js) desloga em QUALQUER 403 — aqui um
// 403 só quer dizer "este perfil não tem a ability", e a ficha tem de continuar aberta.
// Mesmo padrão do `coreClient` do chat (customer_chat/services/staffToken.js).
//
// baseURL e Authorization vêm de `axios.defaults` a cada requisição (o token pode ter
// sido renovado em outra aba). 401/419 continuam sendo problema de sessão: a requisição
// é refeita pela instância global, que adota token novo ou desloga como em todo o app.

const noLogoutClient = axios.create()

// axios 0.x usa objeto simples em `headers`; o 1.x usa AxiosHeaders (com set/delete).
const setHeader = (headers, name, value) => {
  if (headers && typeof headers.set === 'function') headers.set(name, value)
  else if (headers) headers[name] = value // eslint-disable-line no-param-reassign
}

const deleteHeader = (headers, name) => {
  if (headers && typeof headers.delete === 'function') headers.delete(name)
  else if (headers) delete headers[name] // eslint-disable-line no-param-reassign
}

noLogoutClient.interceptors.request.use(config => {
  const next = config
  next.baseURL = axios.defaults.baseURL
  const common = axios.defaults.headers.common || {}
  if (common.Authorization) setHeader(next.headers, 'Authorization', common.Authorization)
  setHeader(next.headers, 'X-Requested-With', 'XMLHttpRequest')
  return next
})

noLogoutClient.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status
    const { config } = error
    if ((status === 401 || status === 419) && config && !config.sessionDelegated) {
      // Sem o Authorization desta tentativa, a instância global aplica o dela (helpers/api.js
      // compara esse token com o do localStorage para decidir entre repetir e deslogar).
      deleteHeader(config.headers, 'Authorization')
      return axios.request({ ...config, sessionDelegated: true })
    }
    return Promise.reject(error)
  },
)

export default noLogoutClient
